import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { IAppState } from '../state/app.state';
import { TraceabilityService } from 'src/app/Services/Traceability/traceability.service';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import {
    TraceabilityActions, GetMLCByInternalCode ,GetRecLotByRecLotId,GetRecLotByMaterialId,GetMLCsByFormulaId,
    GetMaterialTraceability,GetProductTraceability
} from '../actions/traceability.action';

@Injectable()
export class TraceabilityEffects {

    getRecLotByRecLotId$ = createEffect(() => this.actions$.pipe(
        ofType<GetRecLotByRecLotId>(TraceabilityActions.GetRecLotByRecLotId),
        map(action => action.payload),
        mergeMap((payload: any) => this.traceabilityService.getRecLotByRecLotId(payload)
        .pipe(map((result: any) => ({ type: '[Traceability] Get RecLot By RecLotId Success', payload: result})),
         catchError((err) => of({ type: '[] Get RecLot By RecLotId Error', payload: err, from:'getRecLotByRecLotId'}))
         )
        )
    ));

    getMLCByInternalCode$ = createEffect(() => this.actions$.pipe(
        ofType<GetMLCByInternalCode>(TraceabilityActions.GetMLCByInternalCode),
        map(action => action.payload),
        mergeMap((payload: any) => this.traceabilityService.getMLCByInternalCode(payload)
        .pipe(map((result: any) => ({ type: '[Traceability] Get MLC By InternalCode Success', payload: result})),
         catchError((err) => of({ type: '[] Get MLC By InternalCode Error', payload: err, from:'getMLCByInternalCode'}))
         )
        )
    ));

    getRecLotByMaterialId$ = createEffect(() => this.actions$.pipe(
        ofType<GetRecLotByMaterialId>(TraceabilityActions.GetRecLotByMaterialId),
        map(action => action.payload),
        mergeMap((payload: any) => this.traceabilityService.getRecLotByMaterialId(payload)
        .pipe(map((result: any) => ({ type: '[Traceability] Get RecLot By MaterialId Success', payload: result})),
         catchError((err) => of({ type: '[] Get RecLot By MaterialId Error', payload: err, from:'getRecLotByMaterialId'}))
         )
        )
    ));

    getMLCsByFormulaId$ = createEffect(() => this.actions$.pipe(
        ofType<GetMLCsByFormulaId>(TraceabilityActions.GetMLCsByFormulaId),
        map(action => action.payload),
        mergeMap((payload: any) => this.traceabilityService.getMLCsByFormulaId(payload)
        .pipe(map((result: any) => ({ type: '[Traceability] Get MLCs By FormulaId Success', payload: result})),
         catchError((err) => of({ type: '[] Get MLCs By FormulaId Error', payload: err, from:'getMLCsByFormulaId'}))
         )
        )
    ));

    getMaterialTraceability$ = createEffect(() => this.actions$.pipe(
        ofType<GetMaterialTraceability>(TraceabilityActions.GetMaterialTraceability),
        map(action => action.payload),
        mergeMap((payload: any) => this.traceabilityService.getMaterialTraceability(payload)
        .pipe(map((result: any) => ({ type: '[Traceability] Get Material Traceability Success', payload: result})),
         catchError((err) => of({ type: '[] Get Material Traceability Error', payload: err, from:'getMaterialTraceability'}))
         )
        )
    ));

    getProductTraceability$ = createEffect(() => this.actions$.pipe(
        ofType<GetProductTraceability>(TraceabilityActions.GetProductTraceability),
        map(action => action.payload),
        mergeMap((payload: any) => this.traceabilityService.getProductTraceability(payload)
        .pipe(map((result: any) => ({ type: '[Traceability] Get Product Traceability Success', payload: result})),
         catchError((err) => of({ type: '[] Get Product Traceability Error', payload: err, from:'getProductTraceability'}))
         )
        )
    ));

    constructor(private actions$: Actions,
        private store: Store<IAppState>,
        private traceabilityService: TraceabilityService
    ) { }

}
